
// Stop Widows
// const killWidows = [
//     '.no-widows'
// ];

// const nbspWordMin = 6;

// killWidows.forEach(function(selector) {

//     var nbspElements = document.querySelectorAll(selector);
//         nbspElements.forEach(function(element) {
//         var wordCount = (element.innerHTML.split(" ").length);
//         if (wordCount >= nbspWordMin ) {
//             element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1');
//         }
//     });
// });


// Add "Fewsecs"
// let pageContainer = document.getElementById('page-container');

// setTimeout(function () {
//     //pageContainer.classList.add('fewsecs');
// }, 3000);

// Add active class to tag menu
(function () {
	var current = location.pathname.split('/tag/')[1];
	if (current === "") return;
	var menuItems = document.querySelectorAll('.tag-list a');
	for (var i = 0, len = menuItems.length; i < len; i++) {
		if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
			menuItems[i].className += "is-active";
		}
	}
})();
